import { useLongPress } from "@/hooks/useLongPress";

// iMessage-style reaction badges pinned to the bubble's top corner (top-left on sent, top-right on received).
// Tap on your own badge = remove it; tap on someone else's = see who reacted (never edits theirs); long-press = who reacted.
export const TapbackBadges = ({ reactions, meType, meId, align, isLight, onToggle, onShowWho }) => {
  const press = useLongPress(onShowWho);
  if (!reactions || reactions.length === 0) return null;
  const groups = Object.values(reactions.reduce((acc, r) => {
    const g = acc[r.emoji] || (acc[r.emoji] = { emoji: r.emoji, count: 0, names: [], mine: false, at: r.at });
    g.count += 1;
    g.names.push(r.by_name);
    if (r.by_type === meType && r.by_id === meId) g.mine = true;
    if ((r.at || "") > (g.at || "")) g.at = r.at;
    return acc;
  }, {}));

  const others = isLight ? "bg-[#E9E9EB] text-gray-900 ring-white" : "bg-[#3A3A3C] text-white ring-[#1a1a2e]";
  const side = align === "right" ? "left-0 -translate-x-1/3" : "right-0 translate-x-1/3";
  const tail = (mine) => (mine ? "bg-[#0A84FF]" : isLight ? "bg-[#E9E9EB]" : "bg-[#3A3A3C]");

  return (
    <div {...press} className={`absolute -top-3.5 ${side} flex ${align === "right" ? "flex-row" : "flex-row-reverse"} select-none`} style={{ WebkitTouchCallout: "none" }} data-testid="reaction-chips">
      {groups.map((g, i) => (
        <button
          key={`${g.emoji}-${g.at}`}
          type="button"
          onClick={(e) => { e.stopPropagation(); if (g.mine) onToggle(g.emoji); else onShowWho(); }}
          title={g.names.join(", ")}
          className={`tapback-pop relative flex items-center gap-0.5 h-7 px-1.5 rounded-full shadow-md ring-2 ${g.mine ? "bg-[#0A84FF] text-white ring-white shadow-[0_0_0_3px_rgba(10,132,255,0.35)]" : others} ${i > 0 ? "-ml-2" : ""}`}
          style={{ zIndex: groups.length - i, minWidth: 28 }}
          data-testid={`reaction-chip-${g.emoji}`}
        >
          <span className="inline-block text-[15px] leading-[1]" style={{ fontFamily: "'Apple Color Emoji','Segoe UI Emoji','Noto Color Emoji',sans-serif" }}>{g.emoji}</span>
          {g.mine && <span className="text-[10px] font-bold uppercase tracking-wide leading-[1] pl-0.5" data-testid="reaction-chip-mine-label">You{g.count > 1 ? ` +${g.count - 1}` : ""}</span>}
          {!g.mine && g.count > 1 && <span className="text-[11px] font-semibold leading-[1]">{g.count}</span>}
          {i === 0 && (
            <>
              <span className={`absolute -bottom-1 ${align === "right" ? "-left-0.5" : "-right-0.5"} w-2.5 h-2.5 rounded-full ${tail(g.mine)}`} />
              <span className={`absolute -bottom-2 ${align === "right" ? "-left-2" : "-right-2"} w-1.5 h-1.5 rounded-full ${tail(g.mine)}`} />
            </>
          )}
        </button>
      ))}
    </div>
  );
};
